import { z } from 'zod'

export const AGENT_CONSOLE_TOOL_PUBLISH_CONTRACT_VERSION = '1.0.0' as const

export const agentConsoleToolPublishRequestSchema = z.object({
  status: z.enum(['active', 'beta']).default('active'),
})

const publishedToolVersionSchema = z.object({
  id: z.number().int().nonnegative(),
  toolId: z.number().int().nonnegative(),
  toolKey: z.string().min(1),
  version: z.string().min(1),
  status: z.enum(['active', 'beta']),
  remoteUpdatedAt: z.string().datetime(),
  staleAfter: z.string().datetime(),
  publishedAt: z.string().datetime(),
  approvalId: z.number().int().nonnegative(),
}).passthrough()

export const agentConsoleToolPublishResponseSchema = z.object({
  ok: z.literal(true),
  contract_version: z.literal(AGENT_CONSOLE_TOOL_PUBLISH_CONTRACT_VERSION),
  data: z.object({
    tool_version: publishedToolVersionSchema,
    signing: z.object({
      owner: z.literal('agentmcp'),
      state: z.literal('pending_agentmcp_signature'),
    }).passthrough(),
  }).passthrough(),
}).passthrough()

export type AgentConsoleToolPublishRequest = z.infer<typeof agentConsoleToolPublishRequestSchema>
export type AgentConsoleToolPublishResponse = z.infer<typeof agentConsoleToolPublishResponseSchema>
